import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home.icon",
  "use": "home.icon-usage",
  "viewBox": "133.643 -11844.003 24.713 21.007",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"133.643 -11844.003 24.713 21.007\" id=\"home.icon\"><path d=\"M11.885,24.006V16.592h4.943v7.414h6.178V14.121h3.707L14.357,3,2,14.121H5.707v9.885Z\" transform=\"translate(131.643 -11847.003)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/home.icon.svg
// module id = Muzj
// module chunks = 13